import React from 'react';
import styled from 'styled-components';
import Flex from './../Flex/Flex';
import theme from '../../assets/styles/theme';
import DaysHeader from './DaysHeader';
import PillsInfo from './PillsInfo';

const CalendarHeader = ({ header }) => {
  return (
    <Container>
      <Information>
        <Flex>
          <Month>{header.month}</Month>
          <Year>{header.year}</Year>
        </Flex>
        <PillContainer>
          <PillsInfo />
        </PillContainer>
      </Information>

      <DaysHeader />
    </Container>
  );
};

const Container = styled.div`
  height: 100px;
`;

const Information = styled(Flex)`
  height: 50px;
  padding: 10px 20px 15px 20px;
  background-color: ${theme.oldColors.white[500]};
`;

const Month = styled.span`
  font-size: 20px;
  color: ${theme.oldColors.grey[500]};
  margin-left: 10px;
`;

const Year = styled(Month)`
  font-weight: bold;
`;

const PillContainer = styled(Flex)`
  margin-left: auto;
`;

export default CalendarHeader;
